export const FETCH_HOME_DATA = 'FETCH_HOME_DATA';
export const FETCH_ALL_LIVE_DISTROS_WHITELISTED_DEVICES = 'FETCH_All_LIVE_DISTROS_WHITELISTED_DEVICES';

export function fetchHomeData() {
    return {
        type: FETCH_HOME_DATA,
    };
}
